import React from 'react'
import { StyledCheckbox, HiddenInput } from './CheckboxWmo.css'
import IcoMoon from './IcoMoon'
import { CheckboxBlackChecked, CheckboxBlackEmpty } from './Icons/default-icons'

const CheckboxWmo = ({
  label,
  size = 24,
  checked,
  onChange,
  'data-testid': dataTestid,
  name,
// eslint-disable-next-line arrow-body-style
}) => {
  return (
    <StyledCheckbox
      onClick={onChange}
      data-testid={dataTestid}
    >
      <IcoMoon
        icon={checked ? CheckboxBlackChecked : CheckboxBlackEmpty}
        size={size}
      />
      {label}
      <HiddenInput type="checkbox" name={name} defaultChecked={checked} />
    </StyledCheckbox>
  )
}

export default CheckboxWmo
